const DEFAULT_AUTH_RETURN_PATH = "/workspace";

type AuthReturnLocation = {
  pathname: string;
  search: string;
  hash: string;
};

/** 将路由位置序列化为登录后可恢复的完整站内地址。 */
export function buildAuthReturnPath(location: AuthReturnLocation): string {
  return `${location.pathname}${location.search}${location.hash}`;
}

/** 从路由 state 中解析安全的登录回跳地址。 */
export function resolveSafeAuthReturnPath(
  state: unknown,
  origin = typeof window === "undefined" ? "http://flower-master.local" : window.location.origin,
): string {
  const candidate = readReturnPath(state);
  if (
    candidate === null
    || !candidate.startsWith("/")
    || candidate.startsWith("//")
    || candidate.includes("\\")
  ) {
    return DEFAULT_AUTH_RETURN_PATH;
  }

  try {
    const baseUrl = new URL(origin);
    const targetUrl = new URL(candidate, baseUrl);
    const normalizedPathname = (
      decodeURIComponent(targetUrl.pathname)
        .replace(/\/{2,}/g, "/")
        .replace(/\/+$/, "") || "/"
    ).toLowerCase();
    if (
      targetUrl.origin !== baseUrl.origin
      || normalizedPathname === "/auth/login"
      || normalizedPathname === "/auth/logout"
      || normalizedPathname === "/login"
    ) {
      return DEFAULT_AUTH_RETURN_PATH;
    }
  } catch {
    return DEFAULT_AUTH_RETURN_PATH;
  }

  return candidate;
}

/** 读取路由 state 中的原地址字段。 */
function readReturnPath(state: unknown): string | null {
  if (typeof state !== "object" || state === null || !("from" in state)) {
    return null;
  }
  const from = (state as { from?: unknown }).from;
  return typeof from === "string" ? from : null;
}
